const spacing = step => ({
  theme
}) => {
  return theme.spacing[step];
};

export { spacing };
//# sourceMappingURL=spacing.js.map
